import { Box, Stack, UnstyledButton, useMantineTheme } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';
import type { CryptoCatalogNetwork } from '~/services/wallet/interfaces/crypto-direct.interface';
import dt from '~/testing';

import { NetworkIcon } from './NetworkIcon';

type CryptoNetworkListProps = {
  networks: CryptoCatalogNetwork[];
  onSelect: (name: string) => void;
};

/** Screen 1 of the gated crypto deposit flow: pick a Whop network to advance to its asset list. */
export function CryptoNetworkList({ networks, onSelect }: CryptoNetworkListProps) {
  const theme = useMantineTheme();

  return (
    <Box
      component="ul"
      role="list"
      p={0}
      m={0}
      sx={{
        listStyle: 'none',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.other.spacing._8,
      }}
      data-test-id={dt.payments.deposits.cryptoDirect.networkList}
    >
      {networks.map((network) => (
        <Box component="li" key={network.name} p={0} m={0}>
          <UnstyledButton
            aria-label={network.name}
            onClick={() => onSelect(network.name)}
            data-test-id={dt.payments.deposits.cryptoDirect.networkRow}
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: theme.other.spacing._8,
              padding: theme.other.spacing._12,
              borderRadius: theme.radius.md,
              border: `1px solid ${theme.colors.gray2[1]}`,
            }}
          >
            <NetworkIcon name={network.name} iconUrl={network.iconUrl} />
            <Stack spacing={theme.other.spacing._2}>
              <Text variant="subhead-medium">{network.name}</Text>
              <Text variant="body-medium" c="gray2.6">
                {network.assets.map((asset) => asset.symbol).join(', ')}
              </Text>
            </Stack>
          </UnstyledButton>
        </Box>
      ))}
    </Box>
  );
}
